
import { useEffect, useState, useRef } from "react";
import { getLeadsApi } from "../apiServices/fbLeadgenServices";

const getCacheKey = (params) => {
  try {
    return `fb_leads_cache_v2_${JSON.stringify(params || {})}`;
  } catch (e) {
    return "fb_leads_cache_v2_default";
  }
};

const useFbLeads = (params) => {
  const cacheKey = getCacheKey(params);
  const isInitialMount = useRef(true);
  const prevParamsStr = useRef(JSON.stringify(params));

  const [leads, setLeads] = useState(() => {
    try {
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        const parsed = JSON.parse(cached);
        if (Array.isArray(parsed.leads) && parsed.leads.length > 0) {
          return parsed.leads;
        }
      }
    } catch (err) {}
    return [];
  });

  const [pagination, setPagination] = useState(() => {
    try {
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        const parsed = JSON.parse(cached);
        if (parsed.pagination) return parsed.pagination;
      }
    } catch (err) {}
    return {
      page: 1,
      totalPages: 1,
      total: 0,
    };
  });

  const [loading, setLoading] = useState(() => leads.length === 0);

  const fetchLeads = async (force = false) => {
    try {
      if (leads.length === 0 || force) {
        setLoading(true);
      }

      const res = await getLeadsApi(params);
      const data = res?.data;

      const newLeads = data?.leads || [];
      const newPagination = {
        page: data?.page || 1,
        totalPages: data?.totalPages || 1,
        total: data?.total || 0,
        activeCount: data?.activeCount || 0,
        archivedCount: data?.archivedCount || 0,
        totalAll: data?.totalAll || 0,
      };

      setLeads(newLeads);
      setPagination(newPagination);

      try {
        sessionStorage.setItem(cacheKey, JSON.stringify({ leads: newLeads, pagination: newPagination }));
      } catch (err) {}
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const currentParamsStr = JSON.stringify(params);

    if (isInitialMount.current) {
      isInitialMount.current = false;
      if (leads.length > 0) {
        setLoading(false);
        return;
      }
    }

    const hasParamChanged = currentParamsStr !== prevParamsStr.current;
    prevParamsStr.current = currentParamsStr;

    fetchLeads(hasParamChanged);
  }, [JSON.stringify(params)]);

  return { leads, pagination, loading, fetchLeads };
};

export default useFbLeads;